import { buildReducer } from '../../../../shared';
import {
    unifiedGroupSortingChangedAction,
    unifiedGroupListFilterChangedAction,
} from '../../../actions/user/groups/unifiedGroupListActions';
import {
    UnifiedGroupFilter,
    UnifiedGroupSorting,
    UnifiedGroupListViewState,
} from '../../../models/unifiedGroupListViewState';
import { createGroupCompletedAction } from '../../../../editors/actions';
import DisplayOrder from 'owa-people-types/lib/types/DisplayOrder';

const defaultState: UnifiedGroupListViewState = {
    filter: UnifiedGroupFilter.All,
    displayOrder: DisplayOrder.FirstNameLastName,
    sorting: UnifiedGroupSorting.ByRelevancy,
};

export default buildReducer<UnifiedGroupListViewState>()
    .handle(unifiedGroupSortingChangedAction, (state, action) => ({
        ...state,
        sorting: action.payload.sorting,
    }))
    .handle(unifiedGroupListFilterChangedAction, (state, action) => ({
        ...state,
        filter: action.payload.filter,
    }))
    .handle(createGroupCompletedAction, (state, action) => ({
        ...state,
        filter: UnifiedGroupFilter.All,
    }))
    .done(defaultState);
export type { Action } from '../../../../shared';
